import { Navigate } from 'react-router-dom';
import { useCustomerAuth } from '../context/CustomerAuthContext';

export const CustomerProtectedRoute = ({ children }) => {
  const { customerToken, loading } = useCustomerAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f8fafc]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!customerToken) {
    return <Navigate to="/customer-login" replace />;
  }

  return children;
};

export default CustomerProtectedRoute;
